// You can write more code here

/* START OF COMPILED CODE */

import TransitionScene from "../core/scenes/TransitionScene";
import TransitionPrefab from "../prefabs/TransitionPrefab";
/* START-USER-IMPORTS */
import { SceneData, SceneId, TransitionSceneData } from '../app-routing';
import { TransitionType } from '../core/enums/TransitionType';
/* END-USER-IMPORTS */

export default class TransitionLoadScene extends TransitionScene {

  constructor() {
    super("TransitionLoadScene");

    /* START-USER-CTR-CODE */
    this.transitionType = TransitionType.SceneCoverScene;
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // transitionPrefab
    const transitionPrefab = new TransitionPrefab(this, 937, 395);
    this.add.existing(transitionPrefab);
    transitionPrefab.alpha = 1;

    this.transitionPrefab = transitionPrefab;

    this.events.emit("scene-awake");
  }

  private transitionPrefab!: TransitionPrefab;

  /* START-USER-CODE */

  private sceneData!: SceneData;
  private transitionSceneData!: TransitionSceneData;

  init(data: SceneData) {
    super.init(data);

    let transitionDefaults: TransitionSceneData = {
      sourceScene: this.scene.key,
      nextScene: SceneId.Title
    };

    this.transitionSceneData = Object.assign({}, transitionDefaults, data.transitionData);
    this.sceneData = data;
    // this.sceneData.transitionData = undefined;

    // this.scene.bringToTop(this);
  }

  create() {
    super.create();
    this.editorCreate();

    this.beginSceneCoverTransition(this.transitionSceneData, this.transitionPrefab);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
